import React from 'react'

const pages = {
  Home: React.lazy(() => import('./../pages/Home/home')),
  Work: React.lazy(() => import('./../pages/Work/work')),
  Contact: React.lazy(() => import('./../pages/Contact/contact')),
  Resume: React.lazy(() => import('./../pages/Resume/resume')),
}

const mainRoutes = [
  { path: '/', name: 'Homepage', component: <pages.Home /> },
  { path: '/work', name: 'Work', component: <pages.Work /> },
  { path: '/contact', name: 'Contact', component: <pages.Contact /> },
  { path: '/resume', name: 'Resume', component: <pages.Resume /> },
]

export default mainRoutes
